import { ArrowRight } from "lucide-react";
import { IMAGES } from "../data";
import { Reveal } from "./Reveal";

const CARDS = [
  {
    title: "Marriage Hall",
    text: "Elegant venue for weddings, receptions, parties and special occasions.",
    cta: "Explore Hall",
    href: "#marriage-hall",
    img: IMAGES.marriageHall,
    alt: "Elegantly decorated marriage hall at Kasdol Hotel",
    testid: "service-card-marriage-hall",
  },
  {
    title: "Hotel Rooms",
    text: "Comfortable and well-designed rooms for a relaxing stay.",
    cta: "View Rooms",
    href: "#rooms",
    img: IMAGES.rooms,
    alt: "Comfortable premium hotel room at Kasdol Hotel",
    testid: "service-card-hotel-rooms",
  },
  {
    title: "Restaurant",
    text: "A welcoming dining experience for guests, families and celebrations.",
    cta: "Explore Restaurant",
    href: "#restaurant",
    img: IMAGES.restaurant,
    alt: "Warm and welcoming restaurant dining at Kasdol Hotel",
    testid: "service-card-restaurant",
  },
];

export const ServiceCards = () => (
  <section id="services" data-testid="services-section" className="bg-ivory py-16 sm:py-20 lg:py-24">
    <div className="section-wrap">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="eyebrow">Our Experiences</p>
        <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl lg:text-5xl">
          Three Experiences. One Address.
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-6 sm:gap-8 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 120}>
            <article
              data-testid={c.testid}
              className="group h-full overflow-hidden rounded-md bg-white shadow-md transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl"
            >
              <div className="overflow-hidden">
                <img
                  src={c.img}
                  alt={c.alt}
                  loading="lazy"
                  className="h-56 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6 sm:p-7">
                <h3 className="font-serif text-2xl font-semibold text-navy">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70">{c.text}</p>
                <a
                  href={c.href}
                  data-testid={`${c.testid}-cta`}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wider text-gold transition-all duration-300 hover:gap-3 hover:text-gold-hover"
                >
                  {c.cta} <ArrowRight className="h-4 w-4" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
